import React from 'react'

import { useAuth } from '@fourthwall/auth'
import { Button, type ButtonProps } from '@fourthwall/components'

import { useSendVerifyEmailMutation } from '../../../../../../hooks/useSendVerifyEmailMutation'

interface ResendVerificationEmailButtonProps
  extends Omit<ButtonProps, 'onClick' | 'label' | 'size' | 'appearance'> {
  onClick?: () => void
  label?: string
  size?: ButtonProps['size']
  appearance?: ButtonProps['appearance']
}

export const ResendVerificationEmailButton: React.FC<ResendVerificationEmailButtonProps> = ({
  onClick,
  label = 'Resend email',
  size = 'xsmall',
  appearance = 'secondary',
  ...buttonProps
}) => {
  const { user, keycloak } = useAuth()
  const { sendVerifyEmailMutation } = useSendVerifyEmailMutation()

  const isVerified = user?.verified || keycloak?.tokenParsed?.email_verified

  const handleClick = () => {
    sendVerifyEmailMutation.mutate()
    onClick?.()
  }

  if (isVerified) {
    return null
  }

  return (
    <Button
      {...buttonProps}
      label={label}
      size={size}
      appearance={appearance}
      onClick={handleClick}
    />
  )
}
